class LogoSelector extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const savedLogo = localStorage.getItem('selectedLogo') || 'jae';
    this.logoLinks = this.querySelectorAll('.header__left-nav-item');

    this.logoLinks.forEach((link, index) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const logoType = link.getAttribute('data-logo');

        // Save selection to localStorage before navigation
        if (logoType) {
          localStorage.setItem('selectedLogo', logoType);
          localStorage.setItem('pageContext', logoType);
        }

        // Set active state immediately
        this.setActiveLink(link, index);
      });
    });




    // Remove all logo classes and apply the saved one to body
    document.body.classList.remove('jae', 'loyal', 'avalon');
    document.body.classList.add(savedLogo);

    // Find and activate the corresponding logo link
    let activeIndex = 0;
    this.logoLinks.forEach((link, index) => {
      link.classList.remove('active');
      if (link.getAttribute('data-logo') === savedLogo) {
        link.classList.add('active');
        activeIndex = index;
      }
    });

    // Update main logo to match active selection
    if (this.logoLinks[activeIndex]) {
      this.updateMainLogo(activeIndex);
    }

    // Logo will be revealed by updateMainLogo after determining which type to show
  }

  setActiveLink(activeLink, index) {
    this.logoLinks.forEach(link => {
      link.classList.remove('active');
    });
    activeLink.classList.add('active');

    // Get logo type from data-logo attribute
    const logoType = activeLink.getAttribute('data-logo') || 'jae';

    // Remove all logo classes from body and add the new one
    document.body.classList.remove('jae', 'loyal', 'avalon');
    document.body.classList.add(logoType);

    // Always navigate to the corresponding page
    const linkHref = activeLink.getAttribute('href');
    const currentPath = window.location.pathname;
    const targetPath = linkHref ? new URL(linkHref, window.location.origin).pathname : null;
    const isSamePage = targetPath && targetPath === currentPath;
    if (linkHref && linkHref !== '#' && !isSamePage) {
      window.location.href = linkHref;
      return;
    }

    this.dispatchEvent(new CustomEvent('logo-selected', {
      detail: {
        index: index,
        element: activeLink,
        alt: activeLink.querySelector('img')?.alt || '',
        src: activeLink.querySelector('img')?.src || '',
        logo: logoType
      },
      bubbles: true
    }));
  }

  updateMainLogo(logoIndex) {
    // Handle both index (h1.header__logo > a) and other pages (a.header__logo)
    const headerLogoContainer = document.querySelector('.header__logo');
    let mainLogoLink = headerLogoContainer;

    if (headerLogoContainer && headerLogoContainer.tagName === 'H1') {
      // Index page: h1.header__logo contains an <a>
      mainLogoLink = headerLogoContainer.querySelector('a');
    }
    // Else: other pages where a.header__logo is the link itself

    const footerLogoDiv = document.querySelector('.footer__logo');
    const activeNavLogo = this.logoLinks[logoIndex]?.querySelector('img');

    /**
     * Check if text logo mode is enabled
     */


    // Get configuration for current brand
    const useText1 = this.getAttribute('data-use-text-1') === 'true';
    const useText2 = this.getAttribute('data-use-text-2') === 'true';
    const useText3 = this.getAttribute('data-use-text-3') === 'true';
    const useTexts = [useText1, useText2, useText3];
    const useTextForCurrent = useTexts[logoIndex];

    if (mainLogoLink) {
      // Get logo text options from attributes
      const logoText1 = this.getAttribute('data-logo-text-1') || 'JAE';
      const logoText2 = this.getAttribute('data-logo-text-2') || 'LOYAL';
      const logoText3 = this.getAttribute('data-logo-text-3') || 'AVALON';

      const logoNames = [logoText1, logoText2, logoText3];
      const logoName = logoNames[logoIndex] || logoText1;

      if (useTextForCurrent) {
        /* Use text logo */
        mainLogoLink.innerHTML = `
          <span class="header__logo-text h5 logolocal">${logoName}</span>
        `;
        setTimeout(() => {
          const logoText = mainLogoLink.querySelector('.header__logo-text');
          if (logoText) logoText.style.opacity = '1';
          // Remove fixed height after transition
          mainLogoLink.style.minHeight = '';
        }, 0);
      } else if (activeNavLogo) {
        /* Use image logo */
        const navSrc = activeNavLogo.src;
        const headerHighResSrc = navSrc.replace('width=80', 'width=183');
        const footerHighResSrc = navSrc.replace('width=80', 'width=629');

        mainLogoLink.innerHTML = `
          <span class="sr-only">${logoName}</span>
          <img src="${headerHighResSrc}"
               alt="${activeNavLogo.alt}"
               srcset="${headerHighResSrc} 183w, ${headerHighResSrc} 183w"
               width="183"
               height="128"
               sizes="125px"
               class="header__logo-image">
        `;
        setTimeout(() => {
          const logoImage = mainLogoLink.querySelector('.header__logo-image');
          if (logoImage) logoImage.style.opacity = '1';
          // Remove fixed height after transition
          mainLogoLink.style.minHeight = '';
        }, 0);
      }
    }

    this.#switchVisible(['jae-footer-logo', 'loyal-footer-logo', 'avalon-footer-logo'], logoIndex);
    this.#switchVisible(['jae-social-media', 'loyal-social-media', 'avalon-social-media'], logoIndex);
  }

  #switchVisible(ids, activeIndex) {
    ids.forEach((id, i) => {
      const el = document.getElementById(id);
      if (el) el.style.display = i === activeIndex ? '' : 'none';
    });
  }

  setActive(index) {
    if (this.logoLinks[index]) {
      this.setActiveLink(this.logoLinks[index], index);
    }
  }

  getActive() {
    const activeLink = this.querySelector('.header__left-nav-item.active');
    if (activeLink) {
      return {
        element: activeLink,
        alt: activeLink.querySelector('img')?.alt || '',
        src: activeLink.querySelector('img')?.src || ''
      };
    }
    return null;
  }
}

customElements.define('logo-selector', LogoSelector);
